module.exports = __webpack_public_path__ + "public/Icons/deleteIocn.svg?59f23149";